import { render } from "./DeviceNbiot.vue?vue&type=template&id=1ff913a2&scoped=true&ts=true"
import script from "./DeviceNbiot.vue?vue&type=script&lang=ts"
export * from "./DeviceNbiot.vue?vue&type=script&lang=ts"

import "./DeviceNbiot.vue?vue&type=style&index=0&id=1ff913a2&scoped=true&lang=css"

import exportComponent from "E:\\trackzone\\Admin_panel\\admin panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ff913a2"]])

export default __exports__